<template>
  <router-view />
</template>
<style module>
@import url("https://use.fontawesome.com/releases/v5.13.0/css/all.css");
</style>
